import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-multi-check-buttons',
  imports: [],
  templateUrl: './multi-check-buttons.component.html',
  styleUrl: './multi-check-buttons.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiCheckButtonsComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MultiCheckButtonsComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiCheckButtonsComponent {
  @Input() selectOptions: { label: string; value: string }[] = [];
  @Input() hideErrorMessage: boolean = false;
  @Input() errorMessage: string = '';
  @Input() submitAttempted: boolean = false;

  selectedValues: string[] = [];

  private onChange: (value: string[]) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(values: string[]): void {
    this.selectedValues = Array.isArray(values) ? values : [];
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Optionally implement if needed
  }

  toggleValue(value: string) {
    const idx = this.selectedValues.indexOf(value);
    if (idx > -1) {
      this.selectedValues.splice(idx, 1);
    } else {
      this.selectedValues.push(value);
    }
    this.onChange([...this.selectedValues]);
    this.onTouched();
  }

  get isInvalid(): boolean {
    // Check if submitAttempted is true and the control is invalid
    return this.submitAttempted && (
      !this.selectedValues || this.selectedValues.length === 0
    );
  }

  validate(control: AbstractControl): ValidationErrors | null {
    // Example: required validation
    if (control.errors?.['required'] && (!this.selectedValues || this.selectedValues.length === 0)) {
      return { required: true };
    }
    return null;
  }
}
